import React from "react";
import PropTypes from 'prop-types';
import { translatable } from "react-multilingual";
import ServiceSelectField from "./ServiceSelectField";
import { TEST_TYPES_SERVICE } from "../../services/availableServices";


const customMapperHandler = (data) => {
  return data.content.map(item => {
    return {
      value: item.id,
      label: item.name
    }
  });

};


const TestTypesSelectField = ({ label, name, ...other }) => {
  return <ServiceSelectField
    name={name} service={TEST_TYPES_SERVICE}
    // criteria={[{ status: "IN_PRODUCTION" }]}
    customMapper={customMapperHandler}
    label={label} {...other}
  />;
};


TestTypesSelectField.propTypes = {
  name: PropTypes.string.isRequired,
};


const mapTranslationsToProps = ({ labels }) => {
  return { label: labels.select_field.test_type };
};

export default translatable(mapTranslationsToProps)(TestTypesSelectField);
